import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import InputTextPatrocinador from "../cadastro/inputtextPatrocinador";
import useApp from "../../hooks/useAppContext";
import { useParams, useNavigate } from "react-router-dom";
import LinhaPatrocinador from "./linhaPatrocinador";
import ModalAdmPatrociandor from "./modalAdmPatrocinador";
import ApfListaSelecaoPanel from "./apfListaSelecaoPanel";
import {
  FaArrowLeft,
  FaPaperPlane,
  FaSave,
  FaUserPlus,
  FaCloudUploadAlt,
  FaImage,
  FaKey,
  FaCopy,
  FaIdCard,
  FaUsers,
  FaClipboardList,
  FaDesktop,
} from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import api from "../../services/axios";
import "../cadastro/cadastro.css";
import "./admPatrocinadoresList.css";
import "./admFormPatrocinadores.css";

/** Rótulo do select: nome do plano + cota de reuniões. */
const labelPlanoComReunioes = (plano) => {
  const nome = plano?.nome ?? "";
  const qtdRaw = plano?.cotaReunioes ?? plano?.cota_reunioes;
  const qtd = Number(qtdRaw);
  if (qtdRaw === undefined || qtdRaw === null || Number.isNaN(qtd)) {
    return nome || "Plano";
  }
  const textoReunioes = qtd === 1 ? "1 reunião" : `${qtd} reuniões`;
  return `${nome} — ${textoReunioes}`;
};

/** Maior cota de reuniões primeiro; sem valor vai para o fim; desempate por nome. */
const sortPlanosPorReunioesDesc = (lista) => {
  const cotaNum = (p) => {
    const raw = p?.cotaReunioes ?? p?.cota_reunioes;
    if (raw === undefined || raw === null) return null;
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
  };
  return [...lista].sort((a, b) => {
    const qa = cotaNum(a);
    const qb = cotaNum(b);
    const va = qa === null ? Number.NEGATIVE_INFINITY : qa;
    const vb = qb === null ? Number.NEGATIVE_INFINITY : qb;
    if (vb !== va) return vb - va;
    return String(a?.nome ?? "").localeCompare(String(b?.nome ?? ""), "pt-BR");
  });
};

const FORM_TAB_IDENTIDADE = "identidade";
const FORM_TAB_PARTICIPANTES = "participantes";
const FORM_TAB_LISTA_SELECAO = "lista-selecao";

const AdmFormPatrocinadores = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    getPatrocinador,
    getPlanos,
    insertUsuarioAdm,
    atualizaPatrocinadorAdm,
    criarUsuarioPatrocinadorAdm,
  } = useApp();

  const [nomePatrocinador, setNomePatrocinador] = useState("");
  const [email, setEmail] = useState("");
  const [segmento, setSegmento] = useState("");
  const [segmentoOutros, setSegmentoOutros] = useState("");
  const [showSegmentoOutros, setShowSegmentoOutros] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [perfil, setPerfil] = useState("");
  const [idUsuario, setIdUsuario] = useState(false);
  const [isLoadingEnvio, setIsLoadingEnvio] = useState(false);
  const [selecaoReloadKey, setSelecaoReloadKey] = useState(0);
  const [planos, setPlanos] = useState([]);
  const [idPlano, setIdPlano] = useState("");
  const [sequencia, setSequencia] = useState("");

  const [showModalCredenciamento, setShowModalCredenciamento] = useState(false);
  const [emailCredenciamento, setEmailCredenciamento] = useState("");
  const [loadingConsultaCred, setLoadingConsultaCred] = useState(false);
  const [conviteAtivoInfo, setConviteAtivoInfo] = useState(null);
  const [loadingGerarCred, setLoadingGerarCred] = useState(false);
  const [resultadoCredUrl, setResultadoCredUrl] = useState("");

  const [preview, setPreview] = useState(null);
  const [logo, setLogo] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoDragActive, setLogoDragActive] = useState(false);
  const fileInputRef = useRef(null);
  const previewBlobRef = useRef(null);

  useEffect(() => {
    if (id) {
      carregaPatrocinador();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      const lista = await getPlanos();
      const base = Array.isArray(lista) ? lista : [];
      setPlanos(sortPlanosPorReunioesDesc(base));
    })();
  }, [getPlanos]);

  useEffect(() => {
    return () => {
      if (previewBlobRef.current) {
        URL.revokeObjectURL(previewBlobRef.current);
        previewBlobRef.current = null;
      }
    };
  }, []);

  const applyLogoFile = useCallback((file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Use um arquivo de imagem (PNG, JPG, WebP, etc.).");
      return;
    }
    const maxBytes = 15 * 1024 * 1024;
    if (file.size > maxBytes) {
      toast.error("Imagem muito grande. Tamanho máximo: 15 MB.");
      return;
    }
    if (previewBlobRef.current) {
      URL.revokeObjectURL(previewBlobRef.current);
    }
    const url = URL.createObjectURL(file);
    previewBlobRef.current = url;
    setPreview(url);
    setLogo(file);
  }, []);

  const handleLogoInputChange = (e) => {
    const f = e.target.files?.[0];
    if (f) applyLogoFile(f);
    e.target.value = "";
  };

  const openLogoPicker = () => fileInputRef.current?.click();

  const onLogoDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLogoDragActive(true);
  };

  const onLogoDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setLogoDragActive(false);
    }
  };

  const onLogoDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onLogoDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLogoDragActive(false);
    const f = e.dataTransfer.files?.[0];
    if (f) applyLogoFile(f);
  };

  const onLogoZoneKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      openLogoPicker();
    }
  };

  const carregaPatrocinador = async () => {
    let patrocinador = await getPatrocinador(id);
    setNomePatrocinador(patrocinador.patrocinador);
    setEmail(patrocinador.email);
    setParticipantes(patrocinador.usuarios);
    setSegmento(patrocinador.segmento);
    setLogoUrl(patrocinador.logo);
    setPerfil(patrocinador.perfil || "Não informado");
    setIdUsuario(patrocinador.id_usuario);
    const planId =
      patrocinador.id_plano ?? patrocinador.idPlano ?? patrocinador?.plano?.id;
    setIdPlano(planId != null && planId !== "" ? String(planId) : "");
    const seq = patrocinador.sequencia;
    setSequencia(
      seq !== null && seq !== undefined && seq !== "" ? String(seq) : ""
    );
  };

  const [showModal, setShowModal] = useState(false);
  const [validacaoSegmento, setValidacaoSegmento] = useState(true);
  /** Guia lateral: identidade (padrão) | participantes */
  const [formTab, setFormTab] = useState(FORM_TAB_IDENTIDADE);
  const [loadingRecepcao, setLoadingRecepcao] = useState(false);

  const jaTemRecepcao = useMemo(
    () => (participantes || []).some((p) => p?.tipo === "recepcao"),
    [participantes]
  );

  useEffect(() => {
    if (!id) {
      setFormTab(FORM_TAB_IDENTIDADE);
    }
  }, [id]);

  const handleSegmento = (e) => {
    if (e === "") {
      setValidacaoSegmento(false);
    } else {
      setValidacaoSegmento(true);
    }
    if (e === "outros") {
      setShowSegmentoOutros(true);
    } else {
      setShowSegmentoOutros(false);
      setSegmentoOutros("");
    }
    setSegmento(e);
  };

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const incluirParticipante = async (participante) => {
    await insertUsuarioAdm(
      participante.nome,
      participante.cpf,
      participante.dt_nascimento,
      participante.email,
      "participante_patrocinador",
      participante.nome_cracha,
      participante.sexo === "Masculino" ? "masculino" : "feminino",
      participante.celular,
      nomePatrocinador,
      participante.cargo,
      participante.telefone_comercial,
      participante.departamento,
      segmento,
      segmentoOutros,
      id
    );
    if (id) {
      carregaPatrocinador();
    }
  };

  const criarUsuarioRecepcao = async () => {
    if (!id) {
      toast.error("Salve o patrocinador antes de criar o usuário de recepção.");
      return;
    }
    if (jaTemRecepcao) {
      toast.info("Este patrocinador já possui usuário de recepção.");
      return;
    }
    setLoadingRecepcao(true);
    try {
      const response = await api.post("/patrocinador-criar-usuario-recepcao", {
        id_patrocinador: Number(id),
      });
      if (response.status === 200) {
        const emailCriado = response.data?.dados?.usuario?.email;
        toast.success(
          emailCriado
            ? `Usuário de recepção criado: ${emailCriado}`
            : response.data?.mensagem || "Usuário de recepção criado."
        );
        await carregaPatrocinador();
      } else {
        toast.error("Não foi possível criar o usuário de recepção.");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.mensagem ||
          "Erro ao criar usuário de recepção."
      );
    } finally {
      setLoadingRecepcao(false);
    }
  };

  const salvarPatrocinador = async () => {
    if (!segmento) {
      setValidacaoSegmento(false);
      toast.error("Selecione o segmento.");
      return;
    }
    if (idPlano === "" || idPlano === null || idPlano === undefined) {
      toast.error("Selecione a cota de reuniões.");
      return;
    }
    let resp = await atualizaPatrocinadorAdm(
      nomePatrocinador,
      perfil,
      email,
      logo,
      segmento,
      idPlano,
      id ?? null,
      sequencia === "" ? null : Number(sequencia)
    );
    if (!resp?.novoPatrocinadorInsert && !id) {
      toast.error("Não foi possível salvar o patrocinador.");
      return;
    }
    toast.success(
      id
        ? "Patrocinador atualizado com sucesso"
        : "Patrocinador cadastrado com sucesso"
    );
    navigate("/private/adm/patrocinadores");
  };

  const criarUser = async () => {
    let response = await criarUsuarioPatrocinadorAdm(id);
    if (response?.mensagem) {
      toast.success("Usuário criado com sucesso.");
      if (id) {
        carregaPatrocinador();
      }
    } else {
      toast.error("Erro ao criar usuário");
    }
  };

  const enviarSelecao = async (idParticipante) => {
    if (!id) {
      toast.error("ID do patrocinador não encontrado");
      return false;
    }
    if (!idParticipante) {
      toast.error("Selecione o participante destinatário.");
      return false;
    }

    setIsLoadingEnvio(true);
    try {
      const response = await api.post("/patrocinador-enviar-selecao", {
        id_patrocinador: Number(id),
        id_participante: Number(idParticipante),
      });

      if (response.status === 200) {
        toast.success(
          response.data?.mensagem || "Lista de Seleção enviada com sucesso!"
        );
        setSelecaoReloadKey((k) => k + 1);
        return true;
      }
      toast.error("Erro ao enviar Lista de Seleção");
      return false;
    } catch (error) {
      console.error("Erro ao enviar Lista de Seleção:", error);
      toast.error(
        error?.response?.data?.mensagem || "Erro ao enviar Lista de Seleção"
      );
      return false;
    } finally {
      setIsLoadingEnvio(false);
    }
  };

  const abrirModalCredenciamento = async () => {
    setEmailCredenciamento(String(email || "").trim());
    setConviteAtivoInfo(null);
    setResultadoCredUrl("");
    setShowModalCredenciamento(true);
    if (!id) return;
    setLoadingConsultaCred(true);
    try {
      const resp = await api.get(`/patrocinador-credenciamento-token/${id}`);
      if (resp.status === 200 && resp.data?.dados) {
        setConviteAtivoInfo(resp.data.dados);
      }
    } catch {
      /* sem convite ativo ou não autorizado */
    } finally {
      setLoadingConsultaCred(false);
    }
  };

  const gerarTokenCredenciamento = async () => {
    if (!id) {
      toast.error("Salve o patrocinador antes de enviar o convite.");
      return;
    }
    const em = String(emailCredenciamento || "").trim();
    if (!em) {
      toast.error("Informe o e-mail do destinatário do convite.");
      return;
    }
    setLoadingGerarCred(true);
    setResultadoCredUrl("");
    try {
      const resp = await api.post("/patrocinador-credenciamento-token-gerar", {
        id_patrocinador: Number(id),
        email: em,
      });
      if (resp.status === 200 && resp.data?.dados) {
        setResultadoCredUrl(resp.data.dados.url || "");
        toast.success(resp.data.mensagem || "Convite gerado com sucesso.");
        setConviteAtivoInfo({
          email: em.toLowerCase(),
          expires_at: resp.data.dados.expires_at,
          created_at: new Date().toISOString(),
          url: resp.data.dados.url || "",
        });
      }
    } catch (err) {
      const msg =
        err.response?.data?.mensagem || "Erro ao enviar convite.";
      toast.error(msg);
    } finally {
      setLoadingGerarCred(false);
    }
  };

  const copiarCredenciamento = async (texto) => {
    if (!texto) return;
    try {
      await navigator.clipboard.writeText(texto);
      toast.success("Copiado para a área de transferência.");
    } catch {
      toast.error("Não foi possível copiar. Selecione o texto manualmente.");
    }
  };

  /** Link absoluto para exibir/copiar (API pode devolver URL sem origin). */
  const credUrlParaExibir = (urlBruta) => {
    const u = String(urlBruta || "").trim();
    if (!u) return "";
    if (/^https?:\/\//i.test(u)) return u;
    if (u.startsWith("/") && typeof window !== "undefined") {
      return `${window.location.origin}${u}`;
    }
    return u;
  };

  const credExibirUrl = credUrlParaExibir(
    resultadoCredUrl || conviteAtivoInfo?.url
  );

  const patrocinadorResumo = useMemo(
    () => ({
      patrocinador: nomePatrocinador,
      email,
      segmento,
      logo: preview || logoUrl,
    }),
    [nomePatrocinador, email, segmento, preview, logoUrl],
  );

  const titulo = id ? "Editar patrocinador" : "Novo patrocinador";
  const lead = id
    ? "Atualize os dados da instituição, participantes e envie a lista de seleção quando necessário."
    : "Preencha os dados da instituição e salve para incluir participantes e criar o usuário do portal.";

  return (
    <div className="container-adm-main">
      <div className="apl-page apl-page--wide-form">
        <header className="apl-header" aria-label="Cabeçalho do formulário">
          <div className="apl-header-text">
            <h1>{titulo}</h1>
            <p>{lead}</p>
          </div>
          <div className="apl-toolbar">
            {id && (
              <button
                type="button"
                className="apl-btn apl-btn--secondary"
                onClick={abrirModalCredenciamento}
                title="Gerar link de credenciamento SBF 2026"
              >
                <FaKey size={14} aria-hidden />
                Credenciamento 2026
              </button>
            )}
            <button
              type="button"
              className="apl-btn apl-btn--ghost"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeft size={14} aria-hidden />
              Voltar
            </button>
          </div>
        </header>

        <Modal
          show={showModalCredenciamento}
          onHide={() => setShowModalCredenciamento(false)}
          centered
          className="apf-credenciamento-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Convite — credenciamento patrocinador 2026</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="small text-muted mb-3">
              Gera um link único válido por 72 horas e enfileira o envio do
              convite por e-mail. O e-mail deve ser o mesmo cadastrado na ficha
              deste patrocinador. Ao gerar um novo convite, o anterior deixa de
              valer.
            </p>
            {loadingConsultaCred ? (
              <p className="small mb-2">Consultando convite ativo…</p>
            ) : conviteAtivoInfo ? (
              <div className="alert alert-info py-2 px-3 small mb-3">
                Convite ativo para <strong>{conviteAtivoInfo.email}</strong>
                {conviteAtivoInfo.expires_at
                  ? ` (expira em ${new Date(
                      conviteAtivoInfo.expires_at,
                    ).toLocaleString("pt-BR")})`
                  : ""}
                . O link também fica disponível abaixo para cópia. Para substituir este
                convite, use &quot;Enviar convite&quot; com o e-mail da
                instituição.
              </div>
            ) : null}
            <div className="mb-3">
              <label
                className="form-label label-input"
                htmlFor="apf-email-credenciamento"
              >
                E-mail do convite
              </label>
              <input
                id="apf-email-credenciamento"
                type="email"
                className="form-control form-control-lg"
                value={emailCredenciamento}
                onChange={(e) => setEmailCredenciamento(e.target.value)}
                placeholder="mesmo e-mail da instituição"
                autoComplete="email"
              />
            </div>
            {credExibirUrl ? (
              <div className="apf-cred-resultado">
                <label className="form-label small text-muted">Link</label>
                <div className="input-group input-group-sm">
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    value={credExibirUrl}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => copiarCredenciamento(credExibirUrl)}
                    title="Copiar link"
                    disabled={!credExibirUrl}
                  >
                    <FaCopy />
                  </button>
                </div>
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer className="apf-cred-modal-footer">
            <button
              type="button"
              className="apl-btn apl-btn--ghost"
              onClick={() => setShowModalCredenciamento(false)}
            >
              Fechar
            </button>
            <button
              type="button"
              className="apl-btn apl-btn--primary"
              onClick={gerarTokenCredenciamento}
              disabled={loadingGerarCred}
            >
              <FaPaperPlane size={14} aria-hidden />
              {loadingGerarCred ? "Enviando…" : "Enviar convite"}
            </button>
          </Modal.Footer>
        </Modal>

        <div className="body-tela-adm" style={{ paddingBottom: 0 }}>
          <section
            className="apl-card apf-form-card"
            aria-label="Dados do patrocinador"
          >
            <ModalAdmPatrociandor
              titulo="Inclusão de participante"
              show={showModal}
              toggleModal={() => handleModal()}
              footer={true}
              incluirParticipante={incluirParticipante}
            />

            <div className="apf-form-tabs-shell">
              <nav
                className="apf-form-tabs-nav"
                role="tablist"
                aria-label="Seções do formulário"
              >
                <button
                  type="button"
                  role="tab"
                  id="apf-tab-identidade"
                  aria-selected={formTab === FORM_TAB_IDENTIDADE}
                  aria-controls="apf-panel-identidade"
                  className={`apf-form-tab ${
                    formTab === FORM_TAB_IDENTIDADE
                      ? "apf-form-tab--active"
                      : ""
                  }`}
                  onClick={() => setFormTab(FORM_TAB_IDENTIDADE)}
                >
                  <FaIdCard size={14} className="apf-form-tab-icon" aria-hidden />
                  Identidade e contato
                </button>
                <button
                  type="button"
                  role="tab"
                  id="apf-tab-participantes"
                  aria-selected={formTab === FORM_TAB_PARTICIPANTES}
                  aria-controls="apf-panel-participantes"
                  disabled={!id}
                  title={
                    !id
                      ? "Salve o patrocinador para gerenciar participantes."
                      : undefined
                  }
                  className={`apf-form-tab ${
                    formTab === FORM_TAB_PARTICIPANTES
                      ? "apf-form-tab--active"
                      : ""
                  } ${!id ? "apf-form-tab--disabled" : ""}`}
                  onClick={() => id && setFormTab(FORM_TAB_PARTICIPANTES)}
                >
                  <FaUsers size={14} className="apf-form-tab-icon" aria-hidden />
                  Participantes
                </button>
                <button
                  type="button"
                  role="tab"
                  id="apf-tab-lista-selecao"
                  aria-selected={formTab === FORM_TAB_LISTA_SELECAO}
                  aria-controls="apf-panel-lista-selecao"
                  disabled={!id}
                  title={
                    !id
                      ? "Salve o patrocinador para ver a lista de seleção."
                      : undefined
                  }
                  className={`apf-form-tab ${
                    formTab === FORM_TAB_LISTA_SELECAO
                      ? "apf-form-tab--active"
                      : ""
                  } ${!id ? "apf-form-tab--disabled" : ""}`}
                  onClick={() => id && setFormTab(FORM_TAB_LISTA_SELECAO)}
                >
                  <FaClipboardList
                    size={14}
                    className="apf-form-tab-icon"
                    aria-hidden
                  />
                  Lista de seleção
                </button>
              </nav>

              <div className="apf-form-tabs-panels">
                {formTab === FORM_TAB_IDENTIDADE && (
                  <div
                    id="apf-panel-identidade"
                    role="tabpanel"
                    aria-labelledby="apf-tab-identidade"
                    className="apf-form-tabpanel"
                  >
                    <h2 className="apf-section-title">
                      Identidade e contato
                    </h2>
                    <div className="apf-form-layout">
              <div className="apf-logo-card">
                <p className="apf-logo-label">Logotipo da empresa</p>
                <div
                  className={`apf-upload-zone ${
                    logoDragActive ? "apf-upload-zone--active" : ""
                  }`}
                  onDragEnter={onLogoDragEnter}
                  onDragLeave={onLogoDragLeave}
                  onDragOver={onLogoDragOver}
                  onDrop={onLogoDrop}
                  onClick={openLogoPicker}
                  onKeyDown={onLogoZoneKeyDown}
                  role="button"
                  tabIndex={0}
                  aria-label="Enviar logotipo: arraste uma imagem ou pressione Enter para escolher arquivo"
                >
                  <input
                    ref={fileInputRef}
                    type="file"
                    id="input-perfil-adm"
                    className="visually-hidden"
                    accept="image/*"
                    onChange={handleLogoInputChange}
                    tabIndex={-1}
                  />
                  {preview || logoUrl ? (
                    <div className="apf-upload-preview">
                      <img
                        src={preview || logoUrl}
                        alt="Pré-visualização do logotipo"
                        className="apf-upload-preview-img"
                      />
                      <div className="apf-upload-preview-overlay">
                        <FaImage size={20} aria-hidden />
                        <span>Substituir imagem</span>
                      </div>
                    </div>
                  ) : (
                    <div className="apf-upload-empty">
                      <span className="apf-upload-icon-wrap" aria-hidden>
                        <FaCloudUploadAlt size={36} />
                      </span>
                      <p className="apf-upload-title">
                        Arraste o arquivo ou clique para explorar
                      </p>
                      <p className="apf-upload-sub">
                        PNG, JPG, JPEG, GIF ou WebP · até 15 MB
                      </p>
                      <span className="apf-upload-browse">Escolher arquivo</span>
                    </div>
                  )}
                </div>
                <p className="apf-logo-hint">
                  Opcional até salvar. A imagem aparecerá na vitrine do
                  patrocinador após o envio.
                </p>
              </div>

              <div className="apf-controls w-100">
                <div className="row">
                  <div className="col-lg-6 col-12 mb-3">
                    <InputTextPatrocinador
                      label="Nome da Instituição"
                      type="text"
                      requered={true}
                      value={nomePatrocinador}
                      onChange={setNomePatrocinador}
                    />
                  </div>
                  <div className="col-lg-6 col-12 mb-3">
                    <InputTextPatrocinador
                      label="E-mail"
                      type="email"
                      requered={true}
                      value={email}
                      onChange={setEmail}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-12 mb-3">
                    <div className="mb-1">
                      <label
                        className="form-label label-input"
                        htmlFor="input_procura"
                      >
                        Segmento: <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-select form-control form-control-lg ${
                          validacaoSegmento ? "" : "requered-error"
                        }`}
                        aria-label="Segmento do patrocinador"
                        id="input_procura"
                        value={segmento}
                        onChange={(e) => handleSegmento(e.target.value)}
                      >
                        <option value="">Selecione uma opção</option>
                        <option value="tecnologia">Tecnologia</option>
                        <option value="facilities">Facilities</option>
                        <option value="equipamentos">Equipamentos</option>
                        <option value="homecare">Home care</option>
                        <option value="infraestrutura">Infraestrutura</option>
                        <option value="consultoria">Consultoria</option>
                        <option value="logistica">Logistica</option>
                        <option value="consumiveis">Consumiveis</option>
                        <option value="outros">Outros</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12 mb-3">
                    {showSegmentoOutros && (
                      <InputTextPatrocinador
                        label="Descrição do segmento"
                        type="text"
                        value={segmentoOutros}
                        onChange={setSegmentoOutros}
                        requered={showSegmentoOutros}
                      />
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-12 mb-3">
                    <label
                      className="form-label label-input"
                      htmlFor="input_plano_cota"
                    >
                      Cota de reuniões: <span className="text-danger">*</span>
                    </label>
                    <select
                      id="input_plano_cota"
                      className="form-select form-control form-control-lg"
                      aria-label="Plano do patrocinador (cota)"
                      value={idPlano}
                      onChange={(e) => setIdPlano(e.target.value)}
                    >
                      <option value="">Selecione o plano</option>
                      {planos.map((p) => (
                        <option key={p.id} value={p.id}>
                          {labelPlanoComReunioes(p)}
                        </option>
                      ))}
                    </select>
                    <p className="form-text small text-muted mb-0 mt-1">
                      Cotas de reuniões e limites de escolha seguem o plano
                      selecionado.
                    </p>
                  </div>
                  <div className="col-lg-6 col-12 mb-3">
                    <InputTextPatrocinador
                      label="Sequência"
                      type="number"
                      requered={false}
                      value={sequencia}
                      onChange={setSequencia}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mb-1">
                    <label
                      className="form-label label-input"
                      htmlFor="perfil-textarea"
                    >
                      Perfil:
                    </label>
                    <textarea
                      id="perfil-textarea"
                      className="form-control form-control-lg"
                      rows="4"
                      placeholder="Descreva o perfil do patrocinador..."
                      value={perfil}
                      onChange={(e) => setPerfil(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
                  </div>
                )}

                {formTab === FORM_TAB_PARTICIPANTES && (
                  <div
                    id="apf-panel-participantes"
                    role="tabpanel"
                    aria-labelledby="apf-tab-participantes"
                    className="apf-form-tabpanel"
                  >
                    <h2 className="apf-section-title">
                      Participantes vinculados
                    </h2>
                    {id ? (
                      <div
                        className={`apf-participants-panel ${
                          participantes?.length === 0 ? "requered-error" : ""
                        }`}
                        aria-label="Participantes vinculados"
                      >
                        <div className="apf-participants-toolbar">
                          <p className="apf-participants-lead">
                            <span className="apf-participants-count">
                              {participantes?.length ?? 0}
                            </span>
                            {participantes?.length === 1
                              ? " participante vinculado"
                              : " participantes vinculados"}
                          </p>
                          <div className="apf-participants-actions">
                            <button
                              type="button"
                              className="apl-btn apl-btn--secondary"
                              onClick={criarUsuarioRecepcao}
                              disabled={loadingRecepcao || jaTemRecepcao}
                              title={
                                jaTemRecepcao
                                  ? "Já existe usuário de recepção para este patrocinador"
                                  : "Cria usuário recepcao@patrocinador.com.br com senha sbf2026"
                              }
                            >
                              <FaDesktop size={14} aria-hidden />
                              {loadingRecepcao
                                ? "Criando..."
                                : jaTemRecepcao
                                  ? "Recepção já criada"
                                  : "Criar usuário recepção"}
                            </button>
                            <button
                              type="button"
                              className="apl-btn apl-btn--primary"
                              onClick={() => handleModal()}
                            >
                              <FaUserPlus size={14} aria-hidden />
                              Incluir participante
                            </button>
                          </div>
                        </div>

                        <section
                          className="apl-card apf-participants-table-card"
                          aria-label="Lista de participantes"
                        >
                          {participantes?.length ? (
                            <>
                              <div className="apl-table-wrap">
                                <table className="apl-table apf-participants-table">
                                  <thead>
                                    <tr>
                                      <th scope="col">Nome completo</th>
                                      <th scope="col">Nome crachá</th>
                                      <th scope="col">E-mail</th>
                                      <th scope="col">Data credenciamento</th>
                                      <th
                                        scope="col"
                                        style={{ textAlign: "right" }}
                                      >
                                        Ações
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {participantes.map((p) => (
                                      <LinhaPatrocinador
                                        key={p.id}
                                        participante={p}
                                      />
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              <footer className="apl-footer">
                                <span>
                                  Exibindo{" "}
                                  <strong>{participantes.length}</strong>{" "}
                                  {participantes.length === 1
                                    ? "participante"
                                    : "participantes"}
                                </span>
                              </footer>
                            </>
                          ) : (
                            <div className="apl-empty">
                              <p className="apl-empty-title">
                                Nenhum participante incluído
                              </p>
                              <p className="mb-3">
                                Inclua ao menos um participante para concluir o
                                cadastro do patrocinador.
                              </p>
                              <div className="apf-participants-actions">
                                <button
                                  type="button"
                                  className="apl-btn apl-btn--secondary"
                                  onClick={criarUsuarioRecepcao}
                                  disabled={loadingRecepcao || jaTemRecepcao}
                                  title={
                                    jaTemRecepcao
                                      ? "Já existe usuário de recepção para este patrocinador"
                                      : "Cria usuário recepcao@patrocinador.com.br com senha sbf2026"
                                  }
                                >
                                  <FaDesktop size={14} aria-hidden />
                                  {loadingRecepcao
                                    ? "Criando..."
                                    : jaTemRecepcao
                                      ? "Recepção já criada"
                                      : "Criar usuário recepção"}
                                </button>
                                <button
                                  type="button"
                                  className="apl-btn apl-btn--primary"
                                  onClick={() => handleModal()}
                                >
                                  <FaUserPlus size={14} aria-hidden />
                                  Incluir participante
                                </button>
                              </div>
                            </div>
                          )}
                        </section>
                      </div>
                    ) : (
                      <p className="small text-muted mb-0">
                        Salve o patrocinador para incluir e gerenciar
                        participantes.
                      </p>
                    )}
                  </div>
                )}

                {formTab === FORM_TAB_LISTA_SELECAO && (
                  <div
                    id="apf-panel-lista-selecao"
                    role="tabpanel"
                    aria-labelledby="apf-tab-lista-selecao"
                    className="apf-form-tabpanel"
                  >
                    <h2 className="apf-section-title">Lista de seleção</h2>
                    {id ? (
                      <ApfListaSelecaoPanel
                        idPatrocinador={id}
                        patrocinadorResumo={patrocinadorResumo}
                        reloadKey={selecaoReloadKey}
                        onEnviarSelecao={enviarSelecao}
                        isLoadingEnvio={isLoadingEnvio}
                        participantes={participantes}
                      />
                    ) : (
                      <p className="small text-muted mb-0">
                        Salve o patrocinador para visualizar a lista de
                        seleção.
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="apf-form-actions">
              {id && !idUsuario ? (
                <button
                  type="button"
                  className="apl-btn apl-btn--secondary"
                  onClick={() => criarUser()}
                >
                  <FaUserPlus size={14} aria-hidden />
                  Criar usuário do portal
                </button>
              ) : null}
              <button
                type="button"
                className="apl-btn apl-btn--primary"
                onClick={() => salvarPatrocinador()}
              >
                <FaSave size={14} aria-hidden />
                Salvar
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
export default AdmFormPatrocinadores;
